export default __webpack_public_path__ + "images/UX.4f37854.png";